import { useMutation } from 'react-query';

import { putVulnerabilityNewLocation } from 'api/InteractiveMap/putVulnerabilityNewLocation';

const usePutVulnerabilityNewLocation = () => {
  const { isSuccess, mutate: putVulnerabilityNewLocationMutate, isLoading } = useMutation(putVulnerabilityNewLocation);

  return {
    isSuccess,
    putVulnerabilityNewLocation: putVulnerabilityNewLocationMutate,
    isLoading,
  };
};

export default usePutVulnerabilityNewLocation;
